import { Brush, UserCheck, Shield, Heart } from "lucide-react";

const ITEMS = [
  { icon: UserCheck, label: "Hand-reviewed accounts" },
  { icon: Brush, label: "100% original art" },
  { icon: Heart, label: "Direct artist support" },
  { icon: Shield, label: "Secure Stripe checkout" },
];

export const TrustBar = () => (
  <section data-testid="trust-bar" className="border-y border-[#E5E0D8] bg-white">
    <div className="px-6 md:px-12 lg:px-24 py-5 grid grid-cols-2 md:grid-cols-4 gap-6 items-center">
      {ITEMS.map(({ icon: Icon, label }) => (
        <div key={label} className="flex items-center gap-3">
          <Icon className="w-5 h-5 text-[#1E3A8A]" strokeWidth={1.5} />
          <span className="text-sm text-[#333]">{label}</span>
        </div>
      ))}
    </div>
  </section>
);
